import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InventoryService } from 'src/app/services/inventory.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-inventario-historial',
  templateUrl: './inventario-historial.component.html',
  styleUrls: ['./inventario-historial.component.scss']
})
export class InventarioHistorialComponent {

  id:number = 0;
  tipo:string = "";
  historial: {fecha: Date, descripcion: string, cantidad: number, usuario: string}[] = [];

  constructor(
      @Inject(MAT_DIALOG_DATA) public data : any,
      private inventoryS: InventoryService,
    ) { }

    ngOnInit(): void {
      this.id = this.data.id;
      this.tipo = this.data.tipo
      this.getHistorialInventario();
    }

    getHistorialInventario(){
      this.inventoryS.getInventoryHistorial(this.id,this.tipo).subscribe(
        (result: any) => {
          if (result.message == "Success") {
            this.historial = result.data;
          }
        },
        (err: any) => {
          Swal.fire({
            icon: 'error',
            title: 'Error al guarda',
            text: 'Ocurrió un error al guardar el registro, por favor vuelva a intentarlo.'
          });
        }
      );
    }

}
